import { newGuid } from '@/helpers/guid';

export const findParentComponent = (componentInstance, tag) => {
  if (
    componentInstance.$vnode &&
    componentInstance.$vnode.tag &&
    componentInstance.$vnode.tag.endsWith(tag)
  ) {
    return componentInstance;
  }

  if (componentInstance.$parent) {
    return findParentComponent(componentInstance.$parent, tag);
  }

  return null;
};

export const generateId = () => {
  const val = btoa(newGuid().replace(/-/g, '')).slice(0, 14);
  return val;
};

export default {};
